module.exports = __webpack_public_path__ + "static/media/NeedFindingMachine.4bdc5040.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/NeedFindingMachine.PNG
// module id = 69
// module chunks = 0